import { Chip, useTheme } from '@mui/material';
import { ErrorOutlineOutlined } from '@mui/icons-material';

export type InviteStatusType = 'sent' | 'unsent';
export type JobStatusType = 'active' | 'inactive' | 'suspended';

export const InviteStatus = ({ status }: {
  status: InviteStatusType;
}) => {
  const theme = useTheme();
  const InviteStatusMap = {
    sent: {
      display: 'Sent',
      color: theme.palette.green[50],
    },
    unsent: {
      display: 'Not sent',
      color: theme.palette.amber[50],
    },
  } as const;

  const statusText = InviteStatusMap?.[status]?.display ?? 'Unknown';
  const statusColor = InviteStatusMap?.[status]?.color;
  
  return <Chip label={statusText} sx={{ backgroundColor: statusColor }} />
};

export const JobStatus = ({ status }: { status: JobStatusType }) => {
  const theme = useTheme();

  const JobStatusMap = {
    active: {
      display: 'Active',
      color: theme.palette.green[50],
      icon: undefined,
    },
    inactive: { // This is only used for the edit chips, and set the user status to 'dectivated', there won't be users in the list with this status
      display: 'Delete',
      color: theme.palette.red[50],
      icon: <ErrorOutlineOutlined sx={{ fill: theme.palette.error.main }} />,
    },
    suspended: {
      display: 'Suspended',
      color: theme.palette.amber[50],
      icon: undefined,
    },
  } as const;

  const statusText = JobStatusMap?.[status]?.display ?? 'Unknown';
  const statusColor = JobStatusMap?.[status]?.color;
  const statusIcon = JobStatusMap?.[status]?.icon;

  return (
    <Chip
      variant='outlined'
      label={statusText}
      icon={statusIcon}
      sx={{ backgroundColor: statusColor }}
    />
  );
};
